import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import {
  SWAL_SETTINGS,
} from "../../../../utils/Constants";
import {
  handleServerValidations,
} from "../../../../utils/commonfunction";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import {
  SubscriptionPlanDelete,
  SubscriptionPlanList,
  SubscriptionPlanStatus,
} from "../../services/subscriptionPlan.services";

const SubscriptionPlanTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState(0);
  const [itemperpage] = useState(100);
  const [sorting] = useState({ order: -1, column: "createdAt" });
  const [loader, setLoader] = useState(true);
  const [search] = useState({});
  const [globalsearch] = useState("");
  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Subscription plan"), url: "" },
  ];
  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        SubscriptionPlanList(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data.data.list : []);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData);
  }, [
    statsupdate,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

  const viewfunction = (row) => {
    navigate(`/admin/subscription/subscription-plan/view/${row._id}`);
  };

  const ChangeStatus = (data, Num) => {
    // let ids = Array.isArray(data) ? data : [data];
    const formData = new FormData();
    // formData.append("o_id", JSON.stringify(ids));
    formData.append("o_id", data);
    formData.append("status", Num);
    Swal.fire({
      customClass: "swal-wide",
      title: t(
        `Are you sure you want to ${Num === 0 ? "deactivate" : "activate"} this Plan ?`,
      ),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
    }).then((result) => {
      // console.log("result", result);
      if (result.isConfirmed) {
        SubscriptionPlanStatus(formData)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  function Deletefunction(data) {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_delete"),
    }).then((result) => {
      if (result.isConfirmed) {
        SubscriptionPlanDelete(data)
          .then((response) => {
            // console.log("🚀 ~ .then ~ response:", response);
            setStatusUpdate(!statsupdate);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }

  const getPlanGroup = (plan) => {
    if (plan?.plan_group === "current" || Number(plan?.price) === 0) {
      return "current";
    }
    return "other";
  };

  const { currentPlan, otherPlans } = useMemo(() => {
    const current = list.find((item) => getPlanGroup(item) === "current") || null;
    const others = list.filter((item) => getPlanGroup(item) === "other");
    return {
      currentPlan: current,
      otherPlans: others,
    };
  }, [list]);

  const handleAddPlan = () => {
    if (otherPlans.length >= 2) {
      Swal.fire({
        icon: "error",
        text: "Only 2 Other Plans are allowed.",
        ...SWAL_SETTINGS,
      });
      return;
    }
    navigate(`/admin/subscription/subscription-plan/add`);
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">{t("Subscription plan")}</h6>
              {/* <button
                className="btn ripple btn-main-primary signbtn mr-2"
                onClick={handleAddPlan}
              >
                {t("btn_add_new")}
              </button> */}
            </div>
            {loader ? <Loader /> : null}

            {!loader && (
              <div>
                <h5 className="mb-3">Current Plan</h5>
                {currentPlan ? (
                  <div className="card mb-4">
                    <div className="card-body">
                      <h6 className="badge badge-success mb-3">Current Plan</h6>
                      <h4 className="mb-2">${Number(currentPlan?.price || 0)} / month</h4>
                      <p className="mb-2 text-muted">{currentPlan?.plan_name || "N/A"}</p>
                      <p className="mb-3 text-muted">
                        {currentPlan?.description || "No description available."}
                      </p>
                      <div className="d-flex">
                        <button
                          className="btn ripple btn-main-primary signbtn mr-2"
                          onClick={() => viewfunction(currentPlan)}
                        >
                          {t("btn_view")}
                        </button>
                        <button
                          className="btn ripple btn-secondary"
                          onClick={() =>
                            ChangeStatus(currentPlan?._id, currentPlan?.status === 1 ? 0 : 1)
                          }
                        >
                          {currentPlan?.status === 1 ? t("btn_active") : t("btn_inactive")}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <p className="text-muted mb-4">No current plan found.</p>
                )}

                <h5 className="mb-3">Other Plan</h5>
                {otherPlans.length ? (
                  otherPlans.slice(0, 2).map((plan) => (
                    <div className="card mb-3" key={plan?._id}>
                      <div className="card-body">
                        <h6 className="badge badge-warning mb-3">Other Plan</h6>
                        <h4 className="mb-2">${Number(plan?.price || 0)} / {plan?.plan_name === "monthly" ? "Month" : "Year"}</h4>
                        <p className="mb-2 text-muted">{plan?.plan_name || "N/A"}</p>
                        <p className="mb-3 text-muted">
                          {plan?.description || "No description available."}
                        </p>
                        <div className="d-flex">
                          <button
                            className="btn ripple btn-main-primary signbtn mr-2"
                            onClick={() => viewfunction(plan)}
                          >
                            {t("btn_view")}
                          </button>
                          <button
                            className="btn ripple btn-secondary mr-2"
                            onClick={() => ChangeStatus(plan?._id, plan?.status === 1 ? 0 : 1)}
                          >
                            {plan?.status === 1 ? t("btn_active") : t("btn_inactive")}
                          </button>
                          {/* <button
                            className="btn ripple btn-danger"
                            onClick={() => Deletefunction(plan?._id)}
                          >
                            {t("btn_delete")}
                          </button> */}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-muted mb-0">No other plans available.</p>
                )}

                <div className="mt-3">
                  <b>
                    {t("msg_total_records")} : {datalength || 0}
                  </b>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionPlanTable;
